// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"2356713f","656":"f7cb0c07","765":"8b1c315e"}[chunkId] + ".chunk.css";
};